export class GetDataCatalogPipelineCapabilitiesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "engineAvailability",
            "baseName": "engineAvailability",
            "type": "Array<GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner>",
            "format": ""
        },
        {
            "name": "supportedWriteModes",
            "baseName": "supportedWriteModes",
            "type": "Array<DataCatalogPipelineWriteMode>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogPipelineCapabilitiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
